import { rei } from "@/services/api"

class CategoriaService {
  static getCategorias (params) {
    return rei.get(`categoria`, {params}).then(res => res.data)
  }

  static cadastrarCategoria (categoria) {
    return rei.post(`categoria`, categoria).then(res => res.data)
  }

  static atualizarCategoria (categoria, id) {
    return rei.put(`categoria/${id}`, categoria).then(res => res.data)
  }

  static excluirCategoria (id) {
    return rei.delete(`categoria/${id}`)
  }
}

export default CategoriaService
